import {useEffect, useState} from 'react'
import ColorPalette from '../../components/1elements/Thumbnails/ColorPalette'
import {defaultColor, ecoColor, customPalette, mysticNightColor, skyColor, sunnyColor} from '../../styling/Colors'
import FontStyle from '../../components/1elements/Thumbnails/FontStyle'
import Icons from '../../components/1elements/Thumbnails/Icons'
import defaultIconSets from '../../components/1elements/Icons/png/Icons-Default.png'
import customIconSets from '../../components/1elements/Icons/png/Icons-Custom.png'
import boxyIconSets from '../../components/1elements/Icons/png/Icons-Boxy.png'
import modernIconSets from '../../components/1elements/Icons/png/Icons-Modern.png'
import {useNavigate} from 'react-router-dom'
import ApiService from '../../common/ApiCalls'

const useAppearanceConfiguration = (onEditMode, setOnEditMode, isSnackbarOpen, setIsSnackbarOpen, isLoading, setIsLoading) => {
    const navigate = useNavigate()
    const [selectedColors, setSelectedColors] = useState('Default')
    const [selectedFontStyle, setSelectedFontStyle] = useState('Default')
    const [selectedIcons, setSelectedIcons] = useState('Default')

    const resetToDefault = () => {
        setSelectedColors('Default')
        setSelectedFontStyle('Default')
        setSelectedIcons('Default')
    }

    const saveAppearanceConfigurationToLocalStorage = () => {
        localStorage.setItem('colorSelect', selectedColors)
        localStorage.setItem('fontStyleSelect', selectedFontStyle)
        localStorage.setItem('iconsSelect', selectedIcons)
    }

    const handlePreview = () => {
        saveAppearanceConfigurationToLocalStorage()
        localStorage.setItem('previewMode', 'appearance')
        navigate('/')
        window.location.reload()
    }

    const handleCancel = () => {
        setOnEditMode(false)
    }
    const handleSave = async () => {
        setIsLoading(true)
        try{
            await ApiService().setSettings(selectedFontStyle, selectedIcons, selectedColors)
            saveAppearanceConfigurationToLocalStorage()
            setIsLoading(false)
            setIsSnackbarOpen({isOpen: true, message: 'Configuration is saved', severity: 'success'})
            setTimeout(()=>{
                window.location.reload();
            }, 1000)
        }catch(e){
            setIsSnackbarOpen({isOpen: true, message: 'Something went wrong. Please try it again.', severity: 'fail'})
        }
    }

    const [colorOptions,] = useState([
        {
            name: 'Default',
            thumbnail: <ColorPalette colorPalette={defaultColor} />,
            checked: true
        },
        {
            name: 'Yellow',
            thumbnail: <ColorPalette colorPalette={customPalette} />,
            checked: false
        },
        {
            name: 'Sky',
            thumbnail: <ColorPalette colorPalette={skyColor} />,
            checked: false
        },
        {
            name: 'Sunny',
            thumbnail: <ColorPalette colorPalette={sunnyColor} />,
            checked: false
        },
        {
            name: 'Eco',
            thumbnail: <ColorPalette colorPalette={ecoColor} />,
            checked: false
        },
        {
            name: 'Mystic Night',
            thumbnail: <ColorPalette colorPalette={mysticNightColor} />,
            checked: false
        },
    ])

    const [fontStyleOptions,] = useState([
        {
            name: 'Default',
            thumbnail: <FontStyle name={'Montserrat'} />,
            checked: true
        },
        {
            name: 'Roboto',
            thumbnail:  <FontStyle name={'Roboto'} />,
            checked: false
        },
        {
            name: 'Open Sans',
            thumbnail:  <FontStyle name={'Open Sans'} />,
            checked: false
        },
        {
            name: 'Segoe UI',
            thumbnail:  <FontStyle name={'Segoe UI'} />,
            checked: false
        },
    ])

    const [iconsOptions,] = useState([
        {
            name: 'Default',
            thumbnail: <Icons src={defaultIconSets} alt={'Default'} />,
            checked: true
        },
        {
            name: 'Custom',
            thumbnail:  <Icons src={customIconSets} alt={'Custom'} />,
            checked: false
        },
        {
            name: 'Boxy',
            thumbnail:  <Icons src={boxyIconSets} alt={'Boxy'} />,
            checked: false
        },
        {
            name: 'Modern',
            thumbnail:  <Icons src={modernIconSets} alt={'Modern'} />,
            checked: false
        },
    ])

    useEffect(()=>{
        if(!onEditMode){
            const colorsSelect = localStorage.getItem('colorSelect')
            const fontStyleSelect = localStorage.getItem('fontStyleSelect')
            const iconsSelect = localStorage.getItem('iconsSelect')
            setSelectedColors(colorsSelect||'Default')
            setSelectedFontStyle(fontStyleSelect||'Default')
            setSelectedIcons(iconsSelect||'Default')
        }

            const selectedColor = localStorage.getItem('tempColorSelect')
            const selectedFont = localStorage.getItem('tempFontStyleSelect')
            const selectedIcon = localStorage.getItem('tempIconSelect')
            if(selectedColor){
                setOnEditMode(true)
                setSelectedColors(selectedColor)
                setSelectedFontStyle(selectedFont)
                setSelectedIcons(selectedIcon)
                localStorage.removeItem('tempColorSelect')
                localStorage.removeItem('tempFontStyleSelect')
                localStorage.removeItem('tempIconSelect')
            }
    // XXX Fix this in the future
    // eslint-disable-next-line
    }, [onEditMode])

    return {onEditMode, setOnEditMode, handleCancel, handleSave, selectedIcons, setSelectedIcons, selectedFontStyle, isSnackbarOpen, setIsSnackbarOpen,
        setSelectedFontStyle, selectedColors, setSelectedColors, colorOptions, fontStyleOptions, iconsOptions, resetToDefault, isLoading, handlePreview}
}

export default useAppearanceConfiguration
